import {
  CreditPointsData,
  MiddlewareBaseResponse,
  RedeemPointsData,
} from '@ireckonu/shared-ui';

export const CREDIT_POINTS_DATA_MOCK: MiddlewareBaseResponse<CreditPointsData> =
  {
    Data: {
      Departments: [
        { Id: 'Room', Name: 'Room' },
        { Id: 'FoodAndBeverage', Name: 'F&B' },
        { Id: 'Others', Name: 'Others' },
      ],
    },
    Errors: [],
    Success: true,
    Warnings: [],
  };

export const REDEEM_POINTS_DATA_MOCK: MiddlewareBaseResponse<RedeemPointsData> =
  {
    Data: {
      Departments: [
        { Id: 'Room', Name: 'Room' },
        { Id: 'FoodAndBeverage', Name: 'F&B' },
        { Id: 'Others', Name: 'Others' },
      ],
      RedemptionTypes: [
        { Id: 'UpgradeAwards', Name: 'UpgradeAwards' },
        { Id: 'PayByAwards', Name: 'PayByAwards' },
        { Id: 'StayAwards', Name: 'StayAwards' },
        { Id: 'GiftAwards', Name: 'GiftAwards' },
      ],
    },
    Errors: [],
    Success: true,
    Warnings: [],
  };
